// Importing Icon Paths from Parcel DIST folder to be able to use'em in JavaScript
import icons from 'url:../../img/icons.svg'; // Parcel V2 Syntax

export default class View {
  // _parentEl;
  // _data;

  constructor(parentEl) {
    this._parentEl = document.querySelector(parentEl);
  }

  renderSpinner() {
    const markup = `
    <div class="spinner">
      <svg>
        <use href="${icons}#icon-loader"></use>
      </svg>
    </div>`;

    this._clearParentHTML();
    this._insertHTML('afterbegin', markup);
  }
  renderMessage(message = this._message) {
    const markup = `
      <div class="message">
        <div>
          <svg>
            <use href="${icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>`;

    this._clearParentHTML();
    this._insertHTML('afterbegin', markup);
  }
  renderError(message = this._errorMessage) {
    const errMsg = message?.includes('Invalid _id:')
      ? this._errorMessage
      : message;

    const markup = `
      <div class="error">
        <div>
          <svg>
            <use href="${icons}#icon-alert-triangle"></use>
          </svg>
        </div>
        <p>${errMsg}</p>
      </div>`;

    this._clearParentHTML();
    this._insertHTML('afterbegin', markup);
  }
  render(data, render = true) {
    if (!data || (Array.isArray(data) && !data.length))
      return this.renderError();

    this._data = data;
    const markup = this._generateMarkup();

    if (!render) return markup;

    this._clearParentHTML();
    this._insertHTML('afterbegin', markup);
  }
  update(data) {
    this._data = data;
    const newMarkup = this._generateMarkup();

    // Mini Virtual DOM
    const newDOM = document.createRange().createContextualFragment(newMarkup);
    const curElements = this._parentEl.querySelectorAll('*');
    const newElements = newDOM.querySelectorAll('*');

    // DOM Updating Algorithm
    newElements.forEach((newEl, i) => {
      const curEl = curElements[i];

      // Updating Changed Text
      if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim())
        curEl.textContent = newEl.textContent;

      // Updating Changed Attributes
      if (!newEl.isEqualNode(curEl))
        Array.from(newEl.attributes).forEach(attr =>
          curEl.setAttribute(attr.name, attr.value)
        );
    });
  }

  _clearParentHTML() {
    this._parentEl.innerHTML = '';
  }
  _insertHTML(position, markup) {
    this._parentEl.insertAdjacentHTML(position, markup);
  }
}
